import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const QuestionMarkOutlineIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 19 19" {...props}>
            <path
                d="M9.25 17.75C13.9444 17.75 17.75 13.9444 17.75 9.25C17.75 4.55558 13.9444 0.75 9.25 0.75C4.55558 0.75 0.75 4.55558 0.75 9.25C0.75 13.9444 4.55558 17.75 9.25 17.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M6.77661 6.69999C6.97645 6.13191 7.37089 5.65288 7.89007 5.34775C8.40925 5.04262 9.01967 4.93109 9.61321 5.03289C10.2067 5.1347 10.7451 5.44329 11.1329 5.90399C11.5207 6.36469 11.733 6.94778 11.7321 7.54999C11.7321 9.24999 9.18211 10.1 9.18211 10.1V11.375"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M9.25024 13.5001H9.25812"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </SvgIcon>
    );
};
